import { createFileRoute } from "@tanstack/react-router";
import { TabView } from "../../app/components/tabView";

export const Route = createFileRoute("/admin")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TabView
      sections={[
        { path: "articles", label: "Artiklar" },
        { path: "maintenance", label: "Maintenance" },
        { path: "productViewer", label: "Produkter" },
        { path: "methodViewer", label: "Metoder" },
      ]}
    />
  );
}
